import { getRowKey } from '../';
import { PardotEmailTemplateRow } from './PardotEmailTemplateRow';
import { PardotEmailTemplateSearch } from './PardotEmailTemplateSearch';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { SelectionTable } from '@ui/tables';
import { KeyPagination, keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useRef } from 'react';
import { useQueryResource, useSelectionTable } from '@hooks';
export const PardotEmailTemplateSearchableSelectionTableV3 = ({ parentIndex, resourceIdsUri, uri }) => {
    const scrollableListRef = useRef(null);
    const { loading, resource, queryParams, updateParams } = useQueryResource({
        defaultParams: keyPaginationDefaultQueryParams,
        fallbackParams: keyPaginationFallbackQueryParams,
        uri
    });
    const selectionData = useSelectionTable({
        getRowKey,
        queryParams,
        resourceIdsUri,
        results: resource === null || resource === void 0 ? void 0 : resource.results,
        selectionType: SonarObjectType.PardotEmailTemplate
    });
    const renderEmailTemplate = useCallback((record) => React.createElement(PardotEmailTemplateRow, { key: record.sonarObjectId, parentIndex: parentIndex, record: record }), [parentIndex]);
    const results = resource === null || resource === void 0 ? void 0 : resource.results;
    return (React.createElement(React.Fragment, null,
        React.createElement(PardotEmailTemplateSearch, { onChange: updateParams }),
        React.createElement(SelectionTable, { dataSource: results, loading: loading, ref: scrollableListRef, renderRow: renderEmailTemplate, rowKey: getRowKey, selectionData: selectionData, selectionType: PERISCOPE_TAB_TYPES.PARDOT_EMAIL_TEMPLATES }),
        React.createElement(KeyPagination, { defaultPageSize: Number(queryParams.count), listRef: scrollableListRef, onChange: updateParams, resource: resource })));
};
